import { createApp } from 'vue'
import CheckoutStepThree from './CheckoutStepThree'

const el = '.kb-component--checkout-step-three'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CheckoutStepThreeDOM) => {
            const component = createApp(CheckoutStepThree).use(Store)
            component.mount(CheckoutStepThreeDOM)
        })
    }
}
